export default __webpack_public_path__ + "static/media/icon-pinterest.6109842c.svg";